(function(){
    function Slider(){
        this.sliderInit = function () {
            $('.textSlider').slick({
                arrows: true,
                dots: true,
                speed: 500,
                dots: false,
                adaptiveHeight: true,
                prevArrow: '<div class="textSlider__arrowBefore"></div>',
                nextArrow: '<div  class="textSlider__arrowNext"></div>'
            });
            
            $('.js-projectSlider').slick({
                arrows: true,
                dots: true,
                speed: 500,
                dots: false,
                adaptiveHeight: true,
                prevArrow: '<div class="project__arrowBefore"></div>',
                nextArrow: '<div  class="project__arrowNext"></div>' 
            });
        }
    }
    proj.textSlider = new Slider();    
})();